import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { CreateVerificationSessionResponse } from "./create-verification-session.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseCreateVerificationSessionOptions = {
  config?: MutationConfig<typeof vouchersDistributionsRepository.createVerificationSession, AxiosError>;
};

export const useCreateVerificationSession = ({ config }: UseCreateVerificationSessionOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.createVerificationSession(data),
  });
};
